import {
  IGeometryLineModel,
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsTrafficSpeedRangeModel {
  id: string;
  nameFrom: string;
  nameTo: string;
  distance: string;
  speed: string;
  levelOfService: string;
  concordance: string;
  elapsedTime: number;
  expectedValue: number;
  readTime: string;
  readings: number;
  time: string;
  // vectorCode: string;
  typeVector: string;
  typeColor: string;
  rangeTypeName: string;
  markerPopupText: string;
  icon: Icon;
}

export class TrafficSpeedRangeModel extends MarkerModelBase {
  static className = 'TrafficSpeedRangeModel';
  classProperties: IPropsTrafficSpeedRangeModel;

  constructor(
    props: IPropsTrafficSpeedRangeModel,
    geometry: IGeometryLineModel | IGeometryModel,
    lat?: number,
    lng?: number
  ) {
    super(geometry, TrafficSpeedRangeModel.className, lat, lng);
    this.classProperties = props;
    this.geometry = geometry;
  }
}
